module.exports = __webpack_public_path__ + "static/img/withdraw_selected.f0b8c986.svg";